export function getVerticalFocusScrollTarget(scrollNode, layout, options) {
  var config = options || {};
  var currentScrollTop;
  var containerRect;
  var viewportHeight;
  var rawTop;
  var top;
  var itemHeight;
  var bottom;
  var topPadding;
  var bottomPadding;
  var visibleTop;
  var visibleBottom;
  var preferredTop;
  var centerTarget;

  if (!scrollNode || !layout) return 0;

  currentScrollTop = scrollNode.scrollTop || 0;
  viewportHeight =
    scrollNode.clientHeight ||
    (typeof window !== "undefined" ? window.innerHeight : 720);
  containerRect =
    scrollNode.getBoundingClientRect && scrollNode.getBoundingClientRect();

  rawTop = layout.top != null ? layout.top : layout.y || 0;
  top = config.relative
    ? rawTop
    : rawTop - (containerRect && containerRect.top ? containerRect.top : 0);
  itemHeight = layout.itemHeight || layout.rowHeight || layout.height || 0;

  if (itemHeight > viewportHeight * 0.85) {
    itemHeight = Math.min(viewportHeight * 0.35, 420);
  }

  bottom = top + itemHeight;
  topPadding = config.topPadding == null ? 96 : config.topPadding;
  bottomPadding = config.bottomPadding == null ? 128 : config.bottomPadding;
  visibleTop = topPadding;
  visibleBottom = viewportHeight - bottomPadding;
  preferredTop = Math.max(topPadding, (viewportHeight - itemHeight) / 2);

  if (top < visibleTop) {
    if (config.align === "center") {
      centerTarget = currentScrollTop + top - preferredTop;
      return Math.max(0, centerTarget);
    }

    return Math.max(0, currentScrollTop + top - visibleTop);
  }

  if (config.align === "center" && top < preferredTop) {
    centerTarget = currentScrollTop + top - preferredTop;
    return Math.max(0, centerTarget);
  }

  if (bottom > visibleBottom) {
    if (config.align === "center") {
      centerTarget =
        currentScrollTop +
        top -
        preferredTop;
      return Math.max(0, centerTarget);
    }

    return Math.max(0, currentScrollTop + bottom - visibleBottom);
  }

  return currentScrollTop;
}

export function getPaginationFocusEdge(scrollNode, layout, bottomOffset) {
  var containerRect;
  var rawTop;
  var top;
  var height;

  if (!scrollNode || !layout) return 0;

  containerRect =
    scrollNode.getBoundingClientRect && scrollNode.getBoundingClientRect();
  rawTop = layout.top != null ? layout.top : layout.y || 0;
  top = rawTop - (containerRect && containerRect.top ? containerRect.top : 0);
  height = layout.itemHeight || layout.rowHeight || layout.height || 0;

  return top + height - (scrollNode.clientHeight || 0) + (bottomOffset || 0);
}
